import { useState, useEffect, useRef } from 'react';
import api from '../services/api';

const QZ_CERTIFICATE = `-----BEGIN CERTIFICATE-----
MIIECzCCAvOgAwIBAgIGAZy70fWdMA0GCSqGSIb3DQEBCwUAMIGiMQswCQYDVQQG
EwJVUzELMAkGA1UECAwCTlkxEjAQBgNVBAcMCUNhbmFzdG90YTEbMBkGA1UECgwS
UVogSW5kdXN0cmllcywgTExDMRswGQYDVQQLDBJRWiBJbmR1c3RyaWVzLCBMTEMx
HDAaBgkqhkiG9w0BCQEWDXN1cHBvcnRAcXouaW8xGjAYBgNVBAMMEVFaIFRyYXkg
RGVtbyBDZXJ0MB4XDTI2MDMwNDAyMjcwNVoXDTQ2MDMwNDAyMjcwNVowgaIxCzAJ
BgNVBAYTAlVTMQswCQYDVQQIDAJOWTESMBAGA1UEBwwJQ2FuYXN0b3RhMRswGQYD
VQQKDBJRWiBJbmR1c3RyaWVzLCBMTEMxGzAZBgNVBAsMElFaIEluZHVzdHJpZXMs
IExMQzEcMBoGCSqGSIb3DQEJARYNc3VwcG9ydEBxei5pbzEaMBgGA1UEAwwRUVog
VHJheSBEZW1vIENlcnQwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDy
BEjLPM5nHTgzlzaPyk0ABxRztPyF1p/4p4e2JHNAWIt2yXS0L4Zdi6d0eofioGSc
8I+KuhP+c7nm1NWV3Xext4Vse1dQQqXLZzxlpEfSqzu6CRBAVq6bl8hhcRBHklQ8
wJF4Mh9LcDv7DQNSXK49JuLYOFM6hFX/h72/ZU/DilOlLCEJw7/ks8u48aLtzkRr
rT2ngVWgNdHxzX5pxhdb+Ckay1w4aMcktRcWvyJM+iYWt2eBYOZTaeJQB7THiL/N
hQwBQ+Y1ICn/3InZPeOm1dcwwoMCjsBtrAbsulhkd0PbNYZYUCU1tZx6M+WYOLGH
uxPPeM9AaI24xaiJEMslAgMBAAGjRTBDMBIGA1UdEwEB/wQIMAYBAf8CAQEwDgYD
VR0PAQH/BAQDAgEGMB0GA1UdDgQWBBQpIWj5KJSZl7tJTArHXlrHW4v9jTANBgkq
hkiG9w0BAQsFAAOCAQEAl7NpeyAlVvM6SkbCmkhFKZKTyOysA3smLz1E7eV5ZqQv
7mqZyIdWO6XJc9RWCOu21kZ765ADXnM/PvMHjHzKk1DeODwASFrlMaXPDskSad5g
ga/0k5r5NJse0Z+eUQZ4Ng1ZKRwLiblUuBxw87wxMQGp2jiOi/EQ0ZAoTW91F9bX
/6y2TA309JWAH5cFtZLs0HPtertJjoU2bDzk9Iz8exyJFS0WQsQzxU8Js0zr6d4N
loYITv0ymJ3TdOMomPYs7zVxAphUevg0ebCgC8+VI95kMDt5TadFsXHLJbl8rCD0
6wRUuC42VRXsVXuOUu8GXGchNgOcvqHW1YmtND+qMA==
-----END CERTIFICATE-----`;

const QZ_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQDyBEjLPM5nHTgz
lzaPyk0ABxRztPyF1p/4p4e2JHNAWIt2yXS0L4Zdi6d0eofioGSc8I+KuhP+c7nm
1NWV3Xext4Vse1dQQqXLZzxlpEfSqzu6CRBAVq6bl8hhcRBHklQ8wJF4Mh9LcDv7
DQNSXK49JuLYOFM6hFX/h72/ZU/DilOlLCEJw7/ks8u48aLtzkRrrT2ngVWgNdHx
zX5pxhdb+Ckay1w4aMcktRcWvyJM+iYWt2eBYOZTaeJQB7THiL/NhQwBQ+Y1ICn/
3InZPeOm1dcwwoMCjsBtrAbsulhkd0PbNYZYUCU1tZx6M+WYOLGHuxPPeM9AaI24
xaiJEMslAgMBAAECggEASSLsUKbOhTC6VDTlIyzyegipsJHIIjYK39zY0T1QquhX
NQ2KPA2EoG5cq4F/4QexgA/egQDcm++jBVPaO9DSpB0er/rSFwodCkvnX5v2rH5c
rUqh45+OYqzKvE+rqMVauYVEMLuM44JGTgbPsysY6JgAw3C6DhwB1RfTSqy2HxPu
4CdSlaAqigE7ksPrBu04/av4OdtNQxElnojvEEqX6Qnimhj2kgd4GtROGlPYlBgc
vp9AQlAzStmLgJMp4zmObAq82/WVA4nFUlrdZT2zuKkxBGzPYdaChWhIW4NFpPUT
nWbWll1N0dk8ZMqiuzRBDyZjgiAYN/13W8qSPFIi/QKBgQD8gZ7tDXVQn4ds5Vhd
bmtnOk7fiFXTZLpKICDHW/pp8ou+eDdxALloAgdS1Ecp/f0hkjgAeuddcEki0qLP
TTRrD0ssq6NmoMtQHioIqqsRS5E7brPBqPAqHmTMOCXLI/UgfxOqghY2Zgg3RT0P
bD1ds8fx3oubO2Ha0Im21PJEUwKBgQD1XYJjKo8WqPpnYjSKp2OWxfDfYmDkRYIC
sq8PUqTiPsh+SGlU89lGrPF2DIq6EgvOnpUbVgqbz25GFkZLZQI3bpmDa+E+xEow
XjlnZKRPpNF3r7sTHJwqU6MIc55s2zyMx0UviwzHpLXidbKHWdfuvbyt/O1T+MAh
k5Ue17nDpwKBgG4H1ccajDp7qbmsHttn2Gl9IQ2LDUs2o27VnTMCQ5aTWI3BOPeH
B0PpTmOrmO8VfI56dujOpa8z1MrV2phW3jagzXNDv8pi2vWoj0yDglPhCAJL9Qy4
nx7ba7UJ6n4gxxpIBbvRP/iocYAULc1gr0T7qG8fONqF/9gn8zq2hHN9AoGBAL27
ChkOjsjR75dD7CcPWsX619CUrSG20dquOwoZOOCt9bEY40JKsUeicbB78EYDsFec
buZNeTSUiMvva3nfaIBeqJxkLi+v70JJig/2Vcw0QblQDNOxetyMAfSGGwpH2SFu
8YPa/Q3fwrmTk3JwObYlx6GuhAI7xq3wBg5sd/vfAoGBAMtMIh0VnTnFXBbLQ0bz
BAM4fY5xjbwCUDm2HJzsuZ8w5b9H69Ogh7hG9gk/XaBP7jbk+3icbmo03cowwXyF
FfoAOlcPBgHqvut1n9UH37WRF/vcsup81rQjqgS/s8TPKG9fmbuRgPJ2ALjStTB4
9qLkf2Fe9mvvdHK4m+TgsBjO
-----END PRIVATE KEY-----`;

const ESC = '\x1B';
const GS  = '\x1D';
const CMD = {
  INIT:         ESC + '@',
  ALIGN_LEFT:   ESC + 'a\x00',
  ALIGN_CENTER: ESC + 'a\x01',
  BOLD_ON:      ESC + 'E\x01',
  BOLD_OFF:     ESC + 'E\x00',
  SIZE_NORMAL:  GS  + '!\x00',
  SIZE_WIDE:    GS  + '!\x10',
  SIZE_TALL:    GS  + '!\x01',
  CUT:          GS  + 'V\x41\x03',
  FEED:         ESC + 'd\x04',
  LF:           '\n',
};

const separator = (char = '-', width = 48) => char.repeat(width);

const generarESCPOSComanda = (orden, items) => {
  let c = '';
  c += CMD.INIT;
  c += CMD.ALIGN_CENTER + CMD.BOLD_ON;
  c += CMD.SIZE_WIDE + '*** COMANDA ***' + CMD.LF;
  c += CMD.SIZE_NORMAL;

  if (orden.tipo === 'para_llevar') {
    c += CMD.SIZE_WIDE + `PARA LLEVAR #${orden.id}` + CMD.LF;
  } else {
    c += CMD.SIZE_WIDE + `MESA ${orden.mesa?.numero}` + CMD.LF;
    if (orden.mesero?.nombre) c += CMD.SIZE_NORMAL + 'Mesero: ' + orden.mesero.nombre + CMD.LF;
  }

  c += CMD.SIZE_NORMAL + CMD.BOLD_OFF;
  c += CMD.ALIGN_CENTER + new Date().toLocaleTimeString() + CMD.LF;
  c += separator() + CMD.LF;

  c += CMD.ALIGN_LEFT + CMD.BOLD_ON;
  c += 'Descripcion                        Cant.' + CMD.LF;
  c += CMD.BOLD_OFF + separator('-') + CMD.LF;

  items.forEach(item => {
    const nombre = String(item.producto?.nombre ?? 'Producto');
    const cant = `x${item.cantidad}`;
    const espacios = 48 - nombre.length - cant.length;
    c += CMD.SIZE_TALL + nombre + (espacios > 0 ? ' '.repeat(espacios) : ' ') + cant + CMD.LF;
    c += CMD.SIZE_NORMAL;
    if (item.notas) {
      c += '  >> ' + item.notas + CMD.LF;
    }
  });

  c += separator() + CMD.LF;
  c += CMD.ALIGN_CENTER + 'Impreso: ' + new Date().toLocaleString() + CMD.LF;
  c += CMD.FEED + CMD.CUT;
  return c;
};

export default function Cocina() {
  const [ordenes, setOrdenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ultimaActualizacion, setUltimaActualizacion] = useState(null);
  const [ordenesNuevas, setOrdenesNuevas] = useState(new Set());
  const [comandaImprimiendo, setComandaImprimiendo] = useState(null);
  const ordenesAnterioresRef = useRef(new Set());
  const itemsImpresosRef = useRef(new Set(
    JSON.parse(localStorage.getItem('items_impresos') || '[]')
  ));

  // ── Conectar QZ Tray al cargar la pagina ──
  useEffect(() => {
    const qz = window.qz;
    if (!qz) { console.warn('QZ Tray no disponible'); return; }

    qz.security.setCertificatePromise(function(resolve, reject) {
      resolve(QZ_CERTIFICATE);
    });
    qz.security.setSignatureAlgorithm('SHA512');
    qz.security.setSignaturePromise(function(toSign) {
      return function(resolve, reject) {
        const pemBody = QZ_PRIVATE_KEY
          .replace(/-----BEGIN PRIVATE KEY-----/, '')
          .replace(/-----END PRIVATE KEY-----/, '')
          .replace(/\s+/g, '');
        const binaryStr = atob(pemBody);
        const keyBuffer = new Uint8Array(binaryStr.length);
        for (let i = 0; i < binaryStr.length; i++) keyBuffer[i] = binaryStr.charCodeAt(i);
        window.crypto.subtle.importKey('pkcs8', keyBuffer.buffer, { name: 'RSASSA-PKCS1-v1_5', hash: { name: 'SHA-512' } }, false, ['sign'])
          .then(function(cryptoKey) {
            return window.crypto.subtle.sign({ name: 'RSASSA-PKCS1-v1_5' }, cryptoKey, new TextEncoder().encode(toSign));
          })
          .then(function(signature) {
            resolve(btoa(String.fromCharCode(...new Uint8Array(signature))));
          })
          .catch(reject);
      };
    });

    qz.websocket.connect()
      .then(function() { console.log('QZ listo!'); })
      .catch(function(e) { console.error('QZ error:', e); });
  }, []);

  useEffect(() => {
    cargarOrdenes();
    const interval = setInterval(cargarOrdenes, 30000);
    return () => clearInterval(interval);
  }, []);

  const cargarOrdenes = async () => {
    try {
      const res = await api.get('/ordenes/cocina/pendientes');
      const nuevasOrdenes = res.data;

      const idsNuevas = new Set();
      nuevasOrdenes.forEach(orden => {
        if (!ordenesAnterioresRef.current.has(orden.id)) {
          idsNuevas.add(orden.id);
        }
      });

      if (ordenesAnterioresRef.current.size > 0 && idsNuevas.size > 0) {
        setOrdenesNuevas(prev => new Set([...prev, ...idsNuevas]));
      }

      ordenesAnterioresRef.current = new Set(nuevasOrdenes.map(o => o.id));
      setOrdenes(nuevasOrdenes);
      setUltimaActualizacion(new Date().toLocaleTimeString());
    } catch (error) {
      console.error('Error cargando cocina:', error);
    } finally {
      setLoading(false);
    }
  };

  const marcarListo = async (ordenId, itemId) => {
    try {
      await api.post(`/ordenes/${ordenId}/items/${itemId}/listo`);
      setOrdenes(prev => prev.map(orden => {
        if (orden.id !== ordenId) return orden;
        return {
          ...orden,
          items: orden.items.filter(item => item.id !== itemId),
          items_pendientes: orden.items_pendientes - 1,
        };
      }).filter(orden => orden.items.length > 0));
    } catch (error) {
      console.error('Error marcando item listo:', error);
    }
  };

  const getItemsNuevos = (orden) => {
    return orden.items.filter(item => !itemsImpresosRef.current.has(item.id));
  };

  const imprimirComanda = async (orden, soloNuevos = false) => {
    const itemsAImprimir = soloNuevos ? getItemsNuevos(orden) : orden.items;
    if (itemsAImprimir.length === 0) return;

    itemsAImprimir.forEach(item => itemsImpresosRef.current.add(item.id));
    localStorage.setItem('items_impresos', JSON.stringify([...itemsImpresosRef.current]));

    setOrdenesNuevas(prev => {
      const nuevo = new Set(prev);
      nuevo.delete(orden.id);
      return nuevo;
    });

    // Intentar imprimir con QZ Tray
    const qz = window.qz;
    if (qz) {
      try {
        if (!qz.websocket.isActive()) {
          console.log('Reconectando QZ...');
          await qz.websocket.connect();
        }
        const impresora = await qz.printers.getDefault();
        const datos = [{ type: 'raw', format: 'command', data: generarESCPOSComanda(orden, itemsAImprimir) }];
        await qz.print(qz.configs.create(impresora), datos);
        console.log('Comanda enviada correctamente');
        return;
      } catch (err) {
        console.error('Error QZ comanda:', err);
        // cae al fallback
      }
    }

    // Fallback: window.print()
    setComandaImprimiendo({ orden, items: itemsAImprimir });
    setTimeout(() => {
      const baseHeight = 80;
      const heightPerItem = 15;
      const totalHeight = baseHeight + (itemsAImprimir.length * heightPerItem);
      const styleId = 'dynamic-page-size';
      let style = document.getElementById(styleId);
      if (!style) { style = document.createElement('style'); style.id = styleId; document.head.appendChild(style); }
      style.innerHTML = `@page { size: 80mm ${totalHeight}mm; margin: 0; }`;
      window.print();
      setTimeout(() => setComandaImprimiendo(null), 500);
    }, 800);
  };

  const getTipoConfig = (orden) => {
    if (orden.tipo === 'para_llevar') {
      return {
        color: '#3b82f6',
        shadowColor: 'rgba(59,130,246,0.2)',
        titulo: '📦 Para Llevar',
        subtitulo: `Pedido #${orden.id}`,
      };
    }
    return {
      color: '#f59e0b',
      shadowColor: 'rgba(245,158,11,0.2)',
      titulo: `Mesa ${orden.mesa?.numero}`,
      subtitulo: orden.mesero?.nombre,
    };
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <>
      <style>
        {`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          background: #f7fafc;
        }

        @keyframes pulse {
          0% { box-shadow: 0 0 16px rgba(239,68,68,0.5); }
          50% { box-shadow: 0 0 28px rgba(239,68,68,0.9); }
          100% { box-shadow: 0 0 16px rgba(239,68,68,0.5); }
        }

        .comanda-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          padding: 20px;
        }

        .comanda-ticket {
          width: 80mm;
          font-family: Arial, Helvetica, sans-serif;
          font-size: 12px;
          color: #000;
          background: white;
          padding: 8mm;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          margin: 0 auto;
        }

        @media print {
          @page {
            size: 80mm auto;
            margin: 0;
          }

          * {
            visibility: hidden;
          }

          .comanda-wrapper,
          .comanda-wrapper * {
            visibility: visible;
          }

          html,
          body {
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
            overflow: visible !important;
          }

          .comanda-wrapper {
            position: absolute;
            left: 0;
            top: 0;
            width: 80mm;
            padding: 0;
            margin: 0;
          }

          .comanda-ticket {
            box-shadow: none;
            margin: 0;
            padding: 5mm;
            width: 80mm;
            font-size: 14px;
          }
        }
        `}
      </style>

      {/* Vista previa comanda - fallback para window.print() */}
      {comandaImprimiendo && (
        <div className="comanda-wrapper">
          <div className="comanda-ticket">
            <div style={{ textAlign: 'center', marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                *** COMANDA ***
              </div>
              <div style={{ fontWeight: 'bold', fontSize: '18px', marginTop: '4px' }}>
                {comandaImprimiendo.orden.tipo === 'para_llevar'
                  ? `PARA LLEVAR #${comandaImprimiendo.orden.id}`
                  : `MESA ${comandaImprimiendo.orden.mesa?.numero}`}
              </div>
              {comandaImprimiendo.orden.tipo !== 'para_llevar' && (
                <div style={{ fontSize: '12px' }}>
                  Mesero: {comandaImprimiendo.orden.mesero?.nombre}
                </div>
              )}
              <div style={{ fontSize: '11px', color: '#555', marginTop: '4px' }}>
                {new Date().toLocaleTimeString()}
              </div>
            </div>

            <hr style={{ border: 'none', borderTop: '1px dashed #000', margin: '8px 0' }} />

            <div style={{ fontWeight: 'bold', fontSize: '11px', display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', paddingBottom: '4px', marginBottom: '6px' }}>
              <span>Descripción</span>
              <span>Cant.</span>
            </div>

            {comandaImprimiendo.items.map((item, i) => (
              <div key={i}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '6px 0', fontSize: '13px', fontWeight: 'bold' }}>
                  <span>{item.producto?.nombre}</span>
                  <span>x{item.cantidad}</span>
                </div>
                {item.notas && (
                  <div style={{ fontSize: '11px', color: '#333', marginLeft: '8px', marginBottom: '4px' }}>
                    📝 {item.notas}
                  </div>
                )}
              </div>
            ))}

            <hr style={{ border: 'none', borderTop: '1px dashed #000', margin: '8px 0' }} />

            <div style={{ textAlign: 'center', fontSize: '11px', color: '#555' }}>
              Impreso: {new Date().toLocaleString()}
            </div>
          </div>
        </div>
      )}

      {/* Vista normal cocina */}
      {!comandaImprimiendo && (
        <div className="container-fluid p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 style={{ margin: 0 }}>🍳 Vista Cocina</h2>
            <div className="d-flex align-items-center gap-3">
              <small className="text-muted">Última actualización: {ultimaActualizacion}</small>
              <button className="btn btn-outline-primary btn-sm" onClick={cargarOrdenes}>
                🔄 Actualizar
              </button>
            </div>
          </div>

          {ordenes.length === 0 ? (
            <div className="text-center mt-5">
              <div style={{ fontSize: '64px' }}>✅</div>
              <h4 className="text-muted mt-3">No hay pedidos pendientes</h4>
              <p className="text-muted">Todos los pedidos están listos</p>
            </div>
          ) : (
            <div className="row g-3">
              {ordenes.map((orden) => {
                const config = getTipoConfig(orden);
                const esNueva = ordenesNuevas.has(orden.id);
                const itemsNuevos = getItemsNuevos(orden);
                const hayNuevos = itemsNuevos.length > 0;

                return (
                  <div key={orden.id} className="col-md-4 col-lg-3">
                    <div className="card h-100" style={{
                      border: `2px solid ${esNueva ? '#ef4444' : config.color}`,
                      borderRadius: '12px',
                      boxShadow: esNueva ? '0 0 16px rgba(239,68,68,0.5)' : `0 4px 12px ${config.shadowColor}`,
                      animation: esNueva ? 'pulse 1.5s infinite' : 'none',
                    }}>

                      {esNueva && (
                        <div style={{
                          background: '#ef4444',
                          color: 'white',
                          textAlign: 'center',
                          padding: '6px',
                          fontWeight: 'bold',
                          fontSize: '13px',
                          borderRadius: '10px 10px 0 0',
                          letterSpacing: '1px',
                        }}>
                          🔔 NUEVA COMANDA
                        </div>
                      )}

                      <div className="card-header d-flex justify-content-between align-items-center" style={{
                        background: config.color,
                        color: 'white',
                        borderRadius: esNueva ? '0' : '10px 10px 0 0',
                        padding: '12px 16px'
                      }}>
                        <div>
                          <strong style={{ fontSize: '18px' }}>{config.titulo}</strong>
                          <br />
                          <small>{config.subtitulo}</small>
                        </div>
                        <div style={{
                          background: 'rgba(0,0,0,0.2)',
                          borderRadius: '8px',
                          padding: '4px 10px',
                          fontSize: '12px'
                        }}>
                          {orden.items_pendientes} pendiente{orden.items_pendientes !== 1 ? 's' : ''}
                        </div>
                      </div>

                      <div className="card-body p-0">
                        {orden.items.map((item) => (
                          <div key={item.id} className="d-flex justify-content-between align-items-center p-3" style={{
                            borderBottom: '1px solid #f1f5f9',
                            background: item.listo ? '#f0fdf4' : 'white'
                          }}>
                            <div>
                              <div style={{
                                fontWeight: '600',
                                color: item.listo ? '#16a34a' : '#1e293b',
                                textDecoration: item.listo ? 'line-through' : 'none'
                              }}>
                                {item.producto?.nombre}
                                {!itemsImpresosRef.current.has(item.id) && (
                                  <span style={{
                                    background: '#ef4444',
                                    color: 'white',
                                    fontSize: '9px',
                                    padding: '1px 5px',
                                    borderRadius: '4px',
                                    marginLeft: '6px',
                                    fontWeight: 'bold',
                                  }}>NUEVO</span>
                                )}
                              </div>
                              <small className="text-muted">Cantidad: {item.cantidad}</small>
                              {item.notas && (
                                <div>
                                  <small style={{ color: '#ef4444', fontWeight: '600' }}>📝 {item.notas}</small>
                                </div>
                              )}
                            </div>
                            <div>
                              {item.listo ? (
                                <span className="badge bg-success">✓ Listo</span>
                              ) : (
                                <button
                                  className="btn btn-sm btn-success"
                                  onClick={(e) => { e.stopPropagation(); marcarListo(orden.id, item.id); }}
                                  style={{ fontSize: '12px', padding: '4px 10px' }}
                                >
                                  ✓ Listo
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="card-footer" style={{ fontSize: '12px' }}>
                        {hayNuevos && (
                          <button
                            className={`btn w-100 mb-2 ${esNueva ? 'btn-danger' : 'btn-warning'}`}
                            onClick={() => imprimirComanda(orden, true)}
                            style={{ fontWeight: 'bold', fontSize: '13px' }}
                          >
                            🖨️ {esNueva ? 'IMPRIMIR COMANDA' : `Imprimir ${itemsNuevos.length} item(s) nuevo(s)`}
                          </button>
                        )}
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-muted">
                            Enviado: {new Date(orden.items[0]?.updated_at).toLocaleTimeString()}
                          </span>
                          <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => imprimirComanda(orden, false)}
                            style={{ fontSize: '11px', padding: '2px 8px' }}
                          >
                            🖨️ Reimprimir todo
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </>
  );
}